import { Colors } from '../../constants/Colors'

export const navbarStyles = {
   container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      overflow: 'hidden',
      margin: 0,
      padding: 0,
   },
   appBar: {
      position: 'sticky',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      zIndex: 1,
   },
   toolbar: {
      display: 'flex',
      justifyContent: 'flex-start',
   },
   content: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'auto',
      padding: 2,
   },
   title: {
      flexGrow: 1,
      color: Colors.BLACK,
   },
}
